import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { useCallback } from 'react';
import { MenuItemContainer } from '../../components/menuItemContainer';
import { useSocketSend } from '../../context/webSocket/webSocketContext';
import { thunkShowSelfInfo } from '../../redux/actions/selfDataActions';
import { useAppDispatch } from '../../redux/store';
export const RefreshSelfPanelMenuItem = ({ closeMenu }) => {
    const dispatch = useAppDispatch();
    const socketSend = useSocketSend();
    const onClick = useCallback(() => {
        dispatch(thunkShowSelfInfo(socketSend));
    }, [dispatch, socketSend]);
    return _jsx(MenuItemContainer, { label: 'Refresh', onClick: onClick, closeMenu: closeMenu });
};
